import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const isDev =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

function trackPath(path: string) {
  if (typeof navigator === "undefined") return;
  if (navigator.doNotTrack === "1" || (window as any).doNotTrack === "1") return;
  if (!navigator.sendBeacon) return;
  if (isDev) return;
  try {
    const payload = JSON.stringify({
      path,
      ref: document.referrer || null,
      sw: window.screen?.width ?? null,
      src: "logbuch-app",
    });
    navigator.sendBeacon(
      "/api/track",
      new Blob([payload], { type: "application/json" }),
    );
  } catch {}
}

export function useAnalytics() {
  const loc = useLocation();
  useEffect(() => {
    trackPath(loc.pathname);
  }, [loc.pathname]);
}
